<div class="bn-bot-group">
  <div
    class="bn-bot-group__head"
    role="button"
    tabindex="0"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle()">
    <fa-icon
      class="bn-bot-group__chev"
      [icon]="isOpen() ? 'chevron-down' : 'chevron-right'" />
    <span class="bn-bot-group__icon bn-bot-group__icon--{{ meta().color }}">
      <fa-icon [icon]="meta().icon" />
    </span>
    <div class="bn-bot-group__title">
      <h4>
        {{ meta().title }}
        <span class="bn-bot-group__count">{{ bots().length }}</span>
      </h4>
      <p>{{ meta().description }}</p>
    </div>
    <div class="bn-bot-group__summary">
      <div
        class="bn-bot-group__pills"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">
        @for (pill of summaryPills(); track pill.modifier) {
          <span
            ><bn-web-ui-badge
              type="pill"
              [color]="pill.color">
              {{ pill.label }}
            </bn-web-ui-badge></span
          >
        }
        @if (overrideCount() > 0) {
          <button
            class="bn-badge-btn"
            type="button"
            [disabled]="disabled() || categoryLoading()"
            [tooltip]="'Remove all overrides in this category'"
            (click)="clearAllOverrides()">
            <bn-web-ui-badge
              color="blue"
              type="pill">
              {{ overrideCount() }} overridden
              <fa-icon icon="rotate-left" />
            </bn-web-ui-badge>
          </button>
        }
      </div>
      <div
        class="bn-bot-group__bulk"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">
        <bn-web-ui-radio-tabs
          size="sm"
          tooltip="Category default"
          [disabled]="disabled() || categoryLoading()"
          [isLoading]="categoryLoading()"
          [items]="groupPolicyItems"
          [ngModel]="displayedCategoryAction()"
          [showDeselectedIcons]="true"
          (tabItemClickedEvent)="onCategoryTab($event)" />
      </div>
    </div>
  </div>

  @if (isOpen()) {
    <div class="bn-bot-group__body">
      <table class="bn-bot-table">
        <thead>
          <tr>
            <th>BOT</th>
            <th>VERIFICATION</th>
            <th class="text-end">POLICY <span class="text-50-regular">(overrides category default)</span></th>
          </tr>
        </thead>
        <tbody>
          @for (bot of bots(); track bot.botId) {
            <tr>
              <td>
                <code class="text-200-regular text-dark-7">{{ botDisplayName(bot.userAgentMatch) }}</code>
              </td>
              <td>
                @if (bot.isVerifiable) {
                  <span
                    class="bn-bot-verif bn-bot-verif--yes"
                    tabindex="0"
                    [tooltip]="verifiedTpl">
                    <fa-icon icon="circle-check" />
                    Verified
                  </span>
                } @else {
                  <span
                    class="bn-bot-verif bn-bot-verif--no"
                    tabindex="0"
                    [tooltip]="unverifiedTpl">
                    <fa-icon icon="circle-exclamation" />
                    Unverified
                  </span>
                }
              </td>
              <td class="text-end">
                <div class="bn-bot-policy-cell">
                  @if (isOverride(bot)) {
                    <button
                      class="bn-badge-btn"
                      type="button"
                      [disabled]="disabled() || botLoading(bot.botId)() || categoryLoading()"
                      [tooltip]="'Reset to category default'"
                      (click)="clearOverride(bot)">
                      <bn-web-ui-badge
                        color="blue"
                        size="xs"
                        type="pill">
                        Overridden
                        <fa-icon icon="rotate-left" />
                      </bn-web-ui-badge>
                    </button>
                  } @else {
                    <bn-web-ui-badge
                      color="grey"
                      size="xs"
                      type="pill">
                      Inherited
                    </bn-web-ui-badge>
                  }

                  <bn-web-ui-radio-tabs
                    size="sm"
                    [disabled]="disabled() || botLoading(bot.botId)() || categoryLoading()"
                    [isLoading]="botLoading(bot.botId)()"
                    [items]="botPolicyItems(bot)"
                    [ngModel]="displayedAction(bot)"
                    [showDeselectedIcons]="true"
                    (tabItemClickedEvent)="onPolicyTabChange(bot, $event)" />
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<ng-template #verifiedTpl>
  <div class="bn-bot-verif__pop bn-bot-verif__pop--verified p-2">
    <strong class="mb-2">Verified bot</strong><br />
    Requests claiming to be this bot are checked against the vendor’s published IP ranges, so spoofed traffic is rejected.
  </div>
</ng-template>
<ng-template #unverifiedTpl>
  <div class="bn-bot-verif__pop bn-bot-verif__pop--unverified p-2">
    <strong class="mb-2">Unverified bot</strong><br />
    We’re unable to confirm the legitimacy of requests claiming to be this bot. Typically because the vendor publishes no verifiable IP ranges and the bot
    operates from cloud or shared hosting.
  </div>
</ng-template>
